import chef from "./assets/img/chef-king.svg";
import "./App.scss";
import cooking from "./assets/videos/cooking-wok.mp4";
import { useState } from "react";

function App() {
  const [open, setOpen] = useState(false);

  // const showNav = () => {
  //   const hamburger = document.querySelector(".hamburger");
  //   const navLinks = document.querySelector(".nav-links");
  //   const links = document.querySelectorAll(".nav-links li");
  //   return hamburger.addEventListener("click", () => {
  //     console.log("Open Bitches");
  //     navLinks.classList.toggle("open");
  //   });
  // };

  // useEffect(() => {
  //   // showNav();
  // }, [open, setOpen]);

  return (
    <div className="App">
      <NavBar open={open} setOpen={setOpen}></NavBar>
      <div className="parallax">
        <header className="message-header">
          <div className="message-grid">
            <div className="message-grid-1">
              <h1>Delivering food products to the next level</h1>
            </div>
            <div className="message-grid-2">
              <div>
                <p>
                  Food business website that makes it easy to find, engage, and
                  grow your audience.
                </p>
                <div>
                  <button>Try a DEMO</button>
                  <button>Watch Video</button>
                </div>
              </div>
            </div>
            <div className="message-grid-3">
              <video className="videoTag" autoPlay loop muted>
                <source src={cooking} type="video/mp4" />
              </video>
            </div>
          </div>
        </header>
      </div>
      <section className="App-section-1">
        <svg className="svg-build" viewBox="-210 -25 500 150">
          <path d="m78.557 41.867c-2.391 0-4.336 1.936-4.336 4.31v16.748c2.289 1.045 3.674 3.161 3.674 5.463 0 1.531-0.611 2.991-1.729 4.119l-8.886 9.748c-0.411 0.512-0.961 1.308-1.237 2.195-0.152 0.475-0.197 0.983-0.211 1.619h-2.814c0.013-0.89 0.086-1.67 0.346-2.465 0.477-1.537 1.436-2.791 2.002-3.456l8.751-9.375c0.531-0.625 0.82-1.421 0.82-2.239 0-1.896-1.544-3.437-3.44-3.437-0.899 0-1.748 0.34-2.393 0.964l-18.146 18.221c-3.138 3.285-2.932 6.633-2.932 9.139l0.017 6.579h15.564v-2.765c0-1.793 0.35-2.977 1.767-4.312l14.302-15.186c2.047-2.394 3.19-5.456 3.19-8.627v-22.933c0.001-2.374-1.929-4.31-4.309-4.31z" />
          <path d="m13.765 66.062c-0.649-0.621-1.497-0.962-2.394-0.962-1.897 0-3.444 1.54-3.444 3.435 0 0.82 0.29 1.616 0.821 2.241l8.753 9.375c0.565 0.664 1.525 1.916 2.003 3.453 0.257 0.797 0.33 1.575 0.346 2.466h-2.818c-0.011-0.637-0.058-1.146-0.209-1.62-0.275-0.887-0.824-1.682-1.238-2.191l-8.886-9.752c-1.119-1.128-1.729-2.588-1.729-4.119 0-2.302 1.382-4.418 3.674-5.463v-16.748c0-2.374-1.946-4.31-4.337-4.31-2.38 0-4.308 1.936-4.308 4.31v22.933c0 3.171 1.141 6.233 3.188 8.627l14.303 15.185c1.419 1.337 1.766 2.521 1.766 4.313v2.765h15.566l0.018-6.579c0-2.506 0.205-5.854-2.931-9.139l-18.144-18.22z" />
          <path d="m22.111 15.884c2.355 1.942 6.024 1.381 6.024 1.381s-0.151-3.706-2.508-5.648c-2.354-1.941-6.024-1.384-6.024-1.384s0.152 3.71 2.508 5.651z" />
          <path d="m69.078 23.888h-5.948v-2.294c0-1.695-0.638-3.277-1.393-4.764-0.422-0.832-0.89-1.64-1.303-2.478-0.293-0.598-0.572-1.237-0.688-1.901 0.389-0.249 0.531-0.78 0.453-1.24-0.092-0.529-0.594-0.806-1.084-0.806h-1.842-1.797c-0.49 0-0.951 0.211-1.102 0.726-0.139 0.474 0.015 1.055 0.43 1.32-0.191 1.161-0.857 2.252-1.404 3.267-0.718 1.335-1.438 2.695-1.784 4.179-0.286 1.231-0.196 2.547-0.196 3.803v0.189h-4.443c-1.219-1.281-2.579-2.46-3.943-3.246-0.308-0.179-0.402-0.439-0.361-0.689 0.088-0.509 0.726-0.975 1.338-0.625 1.596 0.922 3.135 1.967 4.486 3.184 0 0.001 0.16-1.135-0.049-2.259-0.225-1.198-0.761-2.077-0.761-2.077-1.609-2.193-3.915-4.642-6.229-5.97-0.919-0.528 0.061-1.84 0.979-1.312 1.593 0.916 3.129 1.962 4.479 3.175-1.97-9.833-5.73-14.6-10.487-14.023-2.246 0.271-4.796 1.891-3.533 8.648l2.428 13.014c-1.632-2.199-4.241-3.629-7.189-3.629-3.837 0-7.102 2.416-8.377 5.808h-5.969v34.556h55.289v-34.556zm-5.529 29.027h-44.231v-23.497h44.231v23.497z" />
        </svg>
        <h1>Build your brand and business</h1>
        <span>
          Self-evaluation is about figuring out what one plans to do for the
          rest of the one’s life.
        </span>
      </section>
      <section className="App-section-2">
        <img src={chef} className="App-logo" alt="logo" />
        <h1>Orderstream's Official Website!</h1>
        <span>Ready to help Businesses Soon..</span>
      </section>

      <footer>
        <div>
          <span>© 2021 OrderStream. All Rights Reserved.</span>
        </div>
      </footer>
    </div>
  );
}

const NavBar = (props) => {
  console.log(props);

  const openToggle = () => {
    props.setOpen(!props.open);
  };
  return (
    <>
      <nav>
        <div
          className="hamburger"
          onClick={() => {
            openToggle();
          }}
        >
          <div className="line"></div>
          <div className="line"></div>
          <div className="line"></div>
        </div>
        <div className="nav-brand">
          <a href="#">
            <span className="style-poppins">Order</span>
            <span className="style-cursive">Stream</span>
          </a>
        </div>
        <ul className={props.open ? "nav-links open" : "nav-links"}>
          <li>
            <a href="#">Contact Us</a>
          </li>
          <li>
            <a href="#">About Us</a>
          </li>
          <li>
            <a href="#">Pricing</a>
          </li>
          <li>
            <a href="#">Try a Demo</a>
          </li>
        </ul>
      </nav>
    </>
  );
};

export default App;
